
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.625 9.047c0 .302.008.529.023.68.016.15.042.273.079.367.036.088.08.161.132.219.052.057.125.109.22.156.098.047.25.096.452.148V11H6.258v-.383c.286-.073.487-.154.601-.242a.684.684 0 00.235-.406c.047-.183.07-.49.07-.922V5.773H2.82v3.274c0 .349.01.604.032.765.026.162.065.29.117.383a.697.697 0 00.242.235c.11.062.284.125.523.187V11H.445v-.383c.323-.083.54-.174.649-.273.11-.104.18-.25.21-.438.037-.187.055-.474.055-.86V2.29c0-.36-.013-.62-.039-.781a.911.911 0 00-.133-.383.593.593 0 00-.234-.219A2.428 2.428 0 00.445.72V.336h3.29v.383c-.23.057-.396.114-.5.172a.754.754 0 00-.243.218c-.057.084-.101.211-.133.383a5.85 5.85 0 00-.039.797v2.766h4.344V2.289c0-.453-.023-.763-.07-.93a.711.711 0 00-.219-.382c-.104-.089-.31-.175-.617-.258V.336H9.53v.383c-.291.073-.495.156-.61.25a.684.684 0 00-.233.406c-.042.182-.063.487-.063.914v6.758z","fill":"currentColor"}})])
          )
        }
      }
    